/* IHP compatibility checker. Native cart editor uses current Optionize definitions and addon metadata. */
(function () {
  'use strict';
  const norm = v => String(v || '').normalize('NFKC').trim().toLowerCase();
  const field = (item, name) => Object.entries(item.properties || {}).find(([k]) => norm(k).replace(/:$/, '') === norm(name).replace(/:$/, ''))?.[1] || '';
  const builtins = [
    ['steel-fingers™-blackforge-edition','fingers'],['steel-fingers','fingers'],
    ['original-hand-strips','palm'],['pro-hand-strips','palm'],['extreme-hand-strips','palm'],
    ['original-hand-pucks','palm'],['extreme-hand-pucks','palm'],['palm-puck-1','palm'],
    ['original-foot-pucks','foot'],['extreme-foot-pucks','foot'],['toe-tips-1','foot']
  ];
  const defaults = builtins.map(([handle,area])=>({id:handle,handle,area,backing_property:'Product Backing:',side_property:'Velcro Options:',message:''}));
  const variantValue=(i,name)=> (i.options_with_values||[]).find(o=>norm(o.name)===norm(name))?.value || '';
  const hasLoop=(g,area)=>{const v=norm(variantValue(g,'Options')||g.variant_title);return !v.includes('without') && (area==='fingers'?v.includes('fingers and palm'):v.includes('palm'));};
  const inches=v=>{const m=norm(v).match(/(?:^|\b)([23])\s*(?:inch|in\b|["″])/);return m?Number(m[1]):null;};
  const backingTarget=i=>norm(variantValue(i,'Product')||i.variant_title);
  function matchingBacking(i,b,area){
    const target=backingTarget(b), title=norm(i.product_title||i.title);
    if(area==='fingers')return target.includes('steel fingers');
    if(norm(i.handle)==='palm-puck-1')return target.includes('glide puck');
    return target.length>0 && title.includes(target);
  }
  function evaluate(items, rules) {
    const gloves=items.filter(i=>norm(i.handle)==='slider-gloves');
    const supplies=items.filter(i=>norm(i.handle)==='velcro');
    const glue=items.some(i=>norm(i.product_title||i.title).includes('e6000')||norm(i.handle)==='copy-of-e6000');
    const warnings=[];
    const add=(rule,item,type,message,glove,backing,extra)=>{
      if(!warnings.some(w=>w.item===item&&w.type===type&&w.glove===glove&&w.backing===backing))warnings.push({rule,item,type,message,glove,backing,...extra});
    };
    const missingMessage='No backing or E6000 is in your cart for this item. Add an attachment method, or continue if you already have it.';
    // One glove pair holds one attachment per area. Each unit is one attachment piece set that needs a glove slot.
    const units={};
    for(const rule of rules)for(const item of items){
      if(norm(item.handle)!==norm(rule.handle))continue;
      const backing=norm(field(item,rule.backing_property));
      const loose=supplies.filter(b=>matchingBacking(item,b,rule.area));
      const side=norm([field(item,rule.side_property),...Object.entries(item.properties||{}).filter(([k])=>/velcro/i.test(k)).map(([,v])=>v)].join(' '));
      const looseHook=loose.some(b=>/\bhook\b/.test(norm(variantValue(b,'Option')||b.variant_title)));
      const looseLoop=loose.some(b=>/\bloop\b/.test(norm(variantValue(b,'Option')||b.variant_title)));
      const hook=/\bhook\b/.test(side)||looseHook,loop=/\bloop\b/.test(side)||looseLoop;
      const adhesive=backing.includes('3m')||loose.some(b=>norm(variantValue(b,'Option')||b.variant_title).includes('3m'));
      const missing=(backing==='none'||backing==='') && !loose.length && !glue && !/practice/i.test(item.product_title||'') && !Object.keys(item.properties||{}).some(k=>/kit|bundle|cpb/i.test(k)&&!k.startsWith('_ihp_cpb_'));
      if(rule.area!=='foot'){
        if((backing.includes('velcro')||loose.length) && loop && !hook)add(rule,item,'hook','Loop goes on your gloves. Add hook Velcro for this item, or continue if you already have it.');
        const need=hook&&!loop?'loop':adhesive||loop?'bare':'any';
        (units[rule.area]||=[]).push(...Array.from({length:item.quantity||1},()=>({rule,item,need,adhesive,missing})));
      }else if(missing)add(rule,item,'missing',missingMessage);
      const puckSize=inches(variantValue(item,'Size'));
      if(puckSize && /puck/i.test(item.product_title||item.title||'')){
        const embeddedSize=inches(field(item,'Product Backing Size'))||inches(side)||inches(field(item,rule.backing_property));
        if(embeddedSize && embeddedSize!==puckSize)add(rule,item,'size',`Your ${puckSize}″ puck has ${embeddedSize}″ backing selected. Choose matching ${puckSize}″ backing.`);
        for(const b of loose){const n=inches(variantValue(b,'Product')||b.variant_title);if(n && n!==puckSize)add(rule,item,'size',`Your ${puckSize}″ puck is paired with ${n}″ backing. Choose matching ${puckSize}″ backing.`,null,b);}
      }
    }
    // Pair compatible sets first, so complete sets are never flagged because of other items.
    // Leftover attachments are only checked against leftover glove pairs; with no pairs left they are treated as "own gloves".
    const open={};
    for(const [area,list] of Object.entries(units)){
      const slots=gloves.flatMap(g=>Array.from({length:g.quantity||1},()=>({glove:g,loop:hasLoop(g,area),unit:null})));
      const take=fits=>slots.find(s=>!s.unit&&fits(s));
      const leftover=[];
      for(const need of ['loop','bare'])for(const u of list.filter(u=>u.need===need)){
        const slot=take(s=>s.loop===(need==='loop'));
        if(slot)slot.unit=u;else leftover.push(u);
      }
      for(const u of leftover){
        const slot=take(()=>true);
        if(!slot)continue;
        slot.unit=u;
        const g=slot.glove,label=area==='fingers'?'fingers':'palm';
        if(u.need==='loop'){
          const shared=slots.some(s=>s.glove===g&&s.unit&&s.unit.need==='bare');
          add(u.rule,u.item,'glove',u.rule.message||`Your gloves need loop on the ${label}. Switch gloves or add loose loop.`,g,undefined,{shared});
        }else if(u.adhesive)add(u.rule,u.item,'adhesive','Your gloves already have loop. Choose hook Velcro to attach this item using Velcro.',g);
        else add(u.rule,u.item,'duplicate-loop','Your gloves already have loop here. The extra loose loop may be unnecessary.',g);
      }
      // Items with no backing wait for their own glove pair before they are flagged.
      for(const u of list.filter(u=>u.need==='any')){
        const slot=take(()=>true);
        if(!slot)continue;
        slot.unit=u;
        if(u.missing)add(u.rule,u.item,'missing',missingMessage,slot.glove);
      }
      open[area]=slots.filter(s=>!s.unit).map(s=>s.glove);
    }
    for(const b of supplies){
      const target=backingTarget(b);
      const area=target.includes('steel fingers')?'fingers':/hand|glide|practice/.test(target)?'palm':null;
      if(!area)continue;
      if(items.some(i=>rules.some(r=>norm(i.handle)===norm(r.handle) && matchingBacking(i,b,r.area))))continue;
      // Loose loop or 3M is fine as long as some glove pair in the cart has no loop in this area.
      if(!gloves.length||gloves.some(g=>!hasLoop(g,area)))continue;
      const choice=norm(variantValue(b,'Option')||b.variant_title);
      const r={area,handle:b.handle},g=gloves[0];
      if(/\bloop\b/.test(choice))add(r,b,'duplicate-loop','Your gloves already have loop here. The extra loose loop may be unnecessary.',g,b);
      if(choice.includes('3m'))add(r,b,'adhesive','Your gloves already have loop. Choose hook Velcro if you want to use their Velcro attachment.',g,b);
    }
    warnings.openGloves=area=>open[area]||gloves.flatMap(g=>Array.from({length:g.quantity||1},()=>g));
    return warnings;
  }
  // Only accept one clear replacement addition. Reject changed unrelated lines.
  function editorPlan(before,after,original){
    const old=before.items.find(i=>i.key===original.key);
    if(!old)return null;
    const deltas=[];
    for(const i of before.items){const n=after.items.find(x=>x.key===i.key);if(!n||n.quantity<i.quantity)return null;}
    for(const i of after.items){const previous=before.items.find(x=>x.key===i.key);const delta=i.quantity-(previous?.quantity||0);if(delta){if(delta<0||(i.variant_id!==old.variant_id && !(norm(old.handle)==='velcro' && norm(i.handle)==='velcro' && i.product_id===old.product_id)))return null;deltas.push({item:i,quantity:delta});}}
    if(deltas.length!==1||deltas[0].quantity!==old.quantity)return null;
    const updatedOld=after.items.find(i=>i.key===old.key);
    return {removeKey:old.key,remaining:updatedOld.quantity-old.quantity,addition:deltas[0]};
  }
  // Export pure evaluator for local tests and integrations.
  if (typeof module !== 'undefined' && module.exports) { module.exports = {evaluate, defaults, editorPlan, visibleOptions, editorProperties, matchEditorSize}; return; }
  if (window.IHPCompatibility) return;
  const config = document.getElementById('ihp-compatibility-config');
  if (!config) return;
  const custom = JSON.parse(config.textContent || '[]');
  const rules = [...defaults.filter(d=>!custom.some(c=>norm(c.handle)===norm(d.handle))),...custom];
  const root = window.Shopify?.routes?.root || '/';
  const dialog = document.getElementById('ihp-compatibility-dialog');
  const list = dialog.querySelector('[data-ihp-warnings]');
  const status = dialog.querySelector('[data-ihp-status]');
  const summary = dialog.querySelector('[data-ihp-summary]');
  let busy = false, resume = null, lastFocus = null;
  const json = async (path, data) => {
    const response = await fetch(root + path, {credentials:'same-origin', cache:'no-store', ...(data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {})});
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || 'Unable to update your cart. Please try again.');
    return body;
  };
  const cart = () => json('cart.js');
  const fingerprint = c => JSON.stringify(c.items.map(i => [i.key,i.quantity,i.variant_id,i.properties]));
  function node(tag, text, className) { const e=document.createElement(tag); if(text)e.textContent=text; if(className)e.className=className; return e; }
  function close() { dialog.close(); lastFocus?.focus(); }
  async function replacement(w, c) {
    const g=w.glove;
    // App-linked, priced or bundled lines must be edited through their original builder.
    if (!g || Object.keys(g.properties || {}).length || g.selling_plan_allocation || g.parent_relationship || g.item_components?.length || !g.options_with_values?.length) return null;
    const p = await json('products/slider-gloves.js');
    const index = g.options_with_values.findIndex(o => norm(o.name)==='options');
    if (index<0) return null;
    const desired = w.rule.area==='fingers' ? ['with velcro (fingers and palm)'] : ['with velcro (palm only)','with velcro (fingers and palm)'];
    for (const target of desired) {
      const v=p.variants.find(v => v.available && norm(v.options[index])===target && g.options_with_values.every((o,j)=>j===index || norm(o.value)===norm(v.options[j])));
      // Avoid merging with an existing line: replacement rollback must stay unambiguous.
      if(v && !c.items.some(i=>i.variant_id===v.id))return {...v,ihp_image:v.featured_image?.src||p.featured_image};
    }
    return null;
  }
  function addPhoto(container,item,label){
    const src=item.featured_image?.url||item.image;
    if(!src)return;
    const url=new URL(typeof src==='string'?src:src.src,location.origin);
    if(!['https:','http:'].includes(url.protocol))return;
    const wrap=node('figure',null,'ihp-product-photo');const img=node('img');img.src=url.href;img.alt=item.product_title||item.title||label;img.width=84;img.height=84;wrap.append(img,node('figcaption',label));container.append(wrap);
  }
  const embeddedEditor=false,reconfigure=false;
  const editDialog=document.getElementById('ihp-backing-editor');
  const editorFields=editDialog.querySelector('[data-ihp-editor-fields]');
  const editorStatus=editDialog.querySelector('[data-ihp-editor-status]');
  const saveButton=editDialog.querySelector('[data-ihp-editor-save]');
  let editState=null;
  const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:editState?.before.currency||'USD'}).format(cents/100);
  function visibleOptions(options,selected){
    const visible=new Map();
    const check=o=>{
      if(visible.has(o.id))return visible.get(o.id);
      visible.set(o.id,false);
      if(!o.enableConditionalLogic){visible.set(o.id,true);return true;}
      const hits=(o.conditionalLogicRules||[]).map(r=>{
        const parent=options.find(p=>p.id===r.optionId);
        const values=parent&&check(parent)?selected[parent.id]||[]:[];
        const has=values.includes(r.value);
        if(['contains','is_equal_to'].includes(r.operator))return has;
        if(['does_not_contain','is_not_equal_to'].includes(r.operator))return !has;
        throw new Error('This option uses a rule the cart editor cannot display yet.');
      });
      const match=o.conditionalLogicType==='all'?hits.every(Boolean):hits.some(Boolean);
      const result=o.conditionalLogicAction==='hide'?!match:match;visible.set(o.id,result);return result;
    };
    return options.filter(check);
  }
  function matchEditorSize(st){
    if(st.item.handle!=='palm-puck-1')return;
    const size=inches(variantValue(st.item,'Size')||st.item.variant_title);
    const option=st.options.find(o=>norm(o.name)==='product backing size');
    if(!size||!option)throw new Error('Unable to identify the puck backing size.');
    const value=option.values.find(v=>inches(v.label)===size);
    if(!value)throw new Error('Matching backing is not available for this puck size.');
    st.selected[option.id]=[value.id];
  }
  function renderEditor(){
    const st=editState;editorFields.replaceChildren();
    addPhoto(editorFields,st.item,'');
    editorFields.append(node('p',`${st.item.product_title||st.item.title} · ${st.item.variant_title||''} · Quantity ${st.item.quantity}`));
    if(st.supply){
      const label=node('label','Backing');const select=node('select');select.setAttribute('aria-label','Backing');
      for(const v of st.product.variants){const option=node('option',`${v.title} — ${money(v.price)}`);option.value=v.id;option.disabled=!v.available;option.selected=String(v.id)===String(st.variant);select.append(option);}
      select.addEventListener('change',()=>{st.variant=Number(select.value);});label.append(select);editorFields.append(label);return;
    }
    matchEditorSize(st);
    let total=0;
    for(const o of visibleOptions(st.options,st.selected)){
      if(st.item.handle==='palm-puck-1'&&norm(o.name)==='product backing size')continue;
      const box=node('fieldset');box.append(node('legend',/velcro/i.test(o.name)?'Velcro pieces':o.label||o.name));
      for(const v of o.values){
        const label=node('label',null,'ihp-option-choice');const input=node('input');
        input.type=Number(o.maxSelectedValues||1)>1?'checkbox':'radio';input.name=o.id;input.value=v.id;input.id='ihp-'+o.id+'-'+v.id;input.checked=(st.selected[o.id]||[]).includes(v.id);
        const cents=v.addOnProductVariant?Number(st.cents[v.addOnProductVariant]):0;
        const simple=/^hook/i.test(v.label)?'Hook — for the product':/^loop/i.test(v.label)?'Loop — for the glove':/^3m/i.test(v.label)?'3M Adhesive':v.label;
        label.append(input,node('span',simple+(cents?` (+${money(cents)})`:'')));box.append(label);
        if(input.checked)total+=cents||0;
        input.addEventListener('change',()=>{
          const values=st.selected[o.id]||[];st.selected[o.id]=input.type==='radio'?[v.id]:input.checked?[...new Set([...values,v.id])]:values.filter(id=>id!==v.id);
          renderEditor();document.getElementById(input.id)?.focus();
        });
      }
      editorFields.append(box);
    }
    editorFields.append(node('p',`Backing: ${money(total)} per item.`, 'caption'));
    editorFields.append(node('p','Hook goes on the product. Loop goes on the glove. Supplied loose for you to install.','caption'));
  }
  async function openEditor(key){
    if(busy)return;busy=true;
    try{
      const before=await cart(),item=before.items.find(i=>i.key===key);
      if(!item)throw new Error('This item changed. Refresh your cart and try again.');
      if(item.selling_plan_allocation||item.parent_relationship||item.item_components?.length||Object.keys(item.properties||{}).some(k=>/kit|bundle|cpb/i.test(k)&&!k.startsWith('_ihp_cpb_')))throw new Error('Kit components must be edited through their builder.');
      const product=await json('products/'+encodeURIComponent(item.handle)+'.js');
      if(item.handle==='velcro'){editState={before,item,product,supply:true,variant:item.variant_id};}
      else{
        const url=new URL(root+'products/'+encodeURIComponent(item.handle),location.origin);url.searchParams.set('variant',item.variant_id);
        const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw new Error('Unable to load backing options.');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const read=prefix=>{const e=doc.querySelector(`script[id^="${prefix}"]`);return e?JSON.parse(e.textContent):null;};
        const set=read('optionize-option-set-');const cents=read('optionize-prices-cents-')||{};
        if(!set?.options?.length)throw new Error('No Optionize backing options were found for this item.');
        if(set.options.some(o=>o.type!=='button'||!Array.isArray(o.values)))throw new Error('This product has an option type the cart editor does not support yet.');
        const selected={};for(const o of set.options){const old=String(item.properties?.[o.name]||'');selected[o.id]=old?o.values.filter(v=>old.split(', ').includes(v.label)).map(v=>v.id):Array.isArray(o.value)?o.value:[];}
        editState={before,item,product,options:set.options,cents,selected};
      }
      editorStatus.textContent='';renderEditor();lastFocus=document.activeElement;editDialog.showModal();
    }catch(e){alert(e.message);}finally{busy=false;}
  }
  function editorProperties(st){
    matchEditorSize(st);
    const properties={...st.item.properties};delete properties['_oz-addons'];
    for(const o of st.options)delete properties[o.name];
    const addons=[];
    for(const o of visibleOptions(st.options,st.selected)){
      const values=o.values.filter(v=>(st.selected[o.id]||[]).includes(v.id));
      if(o.required&&!values.length)throw new Error(`Choose ${o.label||o.name}.`);
      if(o.required&&values.length<Number(o.minSelectedValues||1))throw new Error(`Choose more options for ${o.label||o.name}.`);
      if(values.length>Number(o.maxSelectedValues||1))throw new Error(`Choose fewer options for ${o.label||o.name}.`);
      if(values.length)properties[o.name]=values.map(v=>v.label).join(', ');
      for(const v of values){
        if(!v.addOnProductVariant){if(Number(v.addOnPrice))throw new Error('This priced option is not supported yet.');continue;}
        const id=v.addOnProductVariant.split('::')[1],pp=Number(st.cents[v.addOnProductVariant]);
        if(!id||!Number.isFinite(pp)||!Number.isFinite(Number(v.addOnProductVariantPrice)))throw new Error('Unable to verify this backing price.');
        addons.push({id,q:1,p:String(Math.round(Number(v.addOnProductVariantPrice)*100)),n:v.label,pp:String(Math.round(pp))});
      }
    }
    let previous={};try{previous=JSON.parse(st.item.properties?._oz-addons||'{}');}catch{}
    if(addons.length){const publicProperties=Object.fromEntries(Object.entries(properties).filter(([k])=>!k.startsWith('_')));const country=previous.c||(typeof window!=='undefined'?window.Shopify?.country:null);properties['_oz-addons']=JSON.stringify({a:addons,...country&&{c:country},...Object.keys(publicProperties).length&&{o:publicProperties}});}
    return properties;
  }
  editDialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  editDialog.querySelector('[data-ihp-editor-close]').addEventListener('click',()=>{if(busy)return;editDialog.close();editState=null;lastFocus?.focus();});
  saveButton.addEventListener('click',async()=>{
    if(busy||!editState)return;busy=true;saveButton.disabled=true;editorStatus.textContent='Saving…';
    try{
      const st=editState,now=await cart();if(fingerprint(now)!==fingerprint(st.before))throw new Error('Your cart changed. Close this popup and reopen Edit.');
      if(st.supply){
        if(Number(st.variant)===st.item.variant_id){editDialog.close();return;}
        if(now.items.some(i=>i.variant_id===Number(st.variant)))throw new Error('That backing is already in your cart. Adjust its quantity instead.');
        const added=await json('cart/add.js?app=optionize',{items:[{id:st.variant,quantity:st.item.quantity,properties:st.item.properties||{}}]});
        try{await json('cart/change.js',{id:st.item.key,quantity:0});}catch(e){await json('cart/change.js',{id:added.items[0].key,quantity:0});throw e;}
      }else{
        const properties=editorProperties(st);
        // Check catalog identities as well as customer labels: malformed app mappings must not silently sell the wrong size.
        const backing=await json('products/velcro.js');const size=inches(properties['Product Backing Size']);
        let data={};try{data=JSON.parse(properties['_oz-addons']||'{}');}catch{}
        for(const a of data.a||[]){const v=backing.variants.find(v=>String(v.id)===a.id);if(!v?.available)throw new Error('This backing is unavailable. Choose another option.');if(size&&inches(v.title)&&size!==inches(v.title))throw new Error('This backing option is linked to the wrong size. Please choose Velcro or None until we fix the adhesive option.');}
        await json('cart/change.js',{id:st.item.key,quantity:st.item.quantity,properties});
      }
      editDialog.close();editState=null;
      await refreshCart();
    }catch(e){editorStatus.textContent=e.message;}finally{busy=false;saveButton.disabled=false;}
  });
  document.addEventListener('click',event=>{const edit=event.target.closest('[data-ihp-edit-backing]');if(edit){event.preventDefault();openEditor(edit.dataset.ihpEditBacking);}});
  async function refreshCart(){
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||typeof drawer.renderContents!=='function'||/\/cart\/?$/.test(location.pathname)){location.assign(root+'cart');return;}
    try{
      const response=await fetch(root+'?sections=cart-drawer,cart-icon-bubble',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(String(response.status));
      drawer.renderContents({sections:await response.json()});
      schedule();
    }catch{location.assign(root+'cart');}
  }
  const fixHints={hook:'add hook Velcro',glove:'switch to gloves with loop Velcro',adhesive:'change the backing to hook Velcro','duplicate-loop':'remove the extra loop Velcro',size:'choose backing that matches your puck size',missing:'add a backing or E6000 glue'};
  function productRow(item,title,detail){
    const row=node('div',null,'ihp-fix-product');addPhoto(row,item,'');
    const text=node('div');text.append(node('p',title,'ihp-fix-product-title'));
    if(detail && detail!=='Default Title')text.append(node('p',detail,'ihp-fix-product-detail'));
    row.append(text);return row;
  }
  async function show(c, proceed) {
    const warnings=evaluate(c.items,rules);
    if(!warnings.length){ if(proceed)proceed(); return; }
    resume = proceed ? {fingerprint:fingerprint(c),proceed} : null;
    list.replaceChildren(); status.textContent='';
    summary.textContent=`${warnings.length} ${warnings.length===1?'item':'items'} in your cart won't work together as selected. We recommend the fix below before you check out.`;
    for(const [index,w] of warnings.entries()){
      const card=node('article',null,'ihp-compatibility-card');
      const itemTitle=w.item.product_title || w.item.title;
      if(warnings.length>1)card.append(node('p',`Issue ${index+1} of ${warnings.length}`,'ihp-fix-count'));
      const issue=node('div',null,'ihp-fix-section ihp-fix-section--issue');
      issue.append(node('p','Not compatible','ihp-fix-label'),productRow(w.item,itemTitle,w.item.variant_title));
      if(w.glove)issue.append(productRow(w.glove,`With: ${w.glove.product_title || w.glove.title}`,w.glove.variant_title));
      issue.append(node('p',w.message,'ihp-fix-message'));
      const fix=node('div',null,'ihp-fix-section ihp-fix-section--fix');
      fix.append(node('p','Recommended fix','ihp-fix-label'));
      card.append(issue,fix);
      list.append(card);
      const editBacking=(label,className)=>{const link=node('button',label,className);link.type='button';link.addEventListener('click',()=>{close();openEditor((w.backing||w.item).key);});return link;};
      const backingFix=()=>{
        fix.append(node('p',`What changes: ${fixHints[w.type]||'Update the backing'} for ${itemTitle}. You'll review it before saving.`,'ihp-fix-change'));
        fix.append(editBacking(w.backing?'Fix issue: edit backing size':'Fix issue: edit backing','button ihp-fix-button'));
        if(w.type==='missing'){const l=node('a','Shop E6000 glue','ihp-fix-secondary');l.href=root+'products/copy-of-e6000';fix.append(l);}
      };
      if(w.type!=='glove' || !w.glove || w.shared){backingFix();continue;}
      {
        try{
          const v=await replacement(w,c);
          if(v){
            const price=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:c.currency}).format(v.price/100);
            fix.append(productRow({image:v.ihp_image,product_title:w.glove.product_title||w.glove.title},`${w.glove.product_title || w.glove.title} — ${v.title}`,`${price} each`));
            fix.append(node('p',`What changes: your gloves (${w.glove.variant_title || 'current version'}, qty ${w.glove.quantity}) will be replaced with ${v.title}.`,'ihp-fix-change'));
            const btn=node('button','Fix issue: switch my gloves','button ihp-fix-button'); btn.type='button'; fix.append(btn);
            fix.append(editBacking('Or change the backing instead','ihp-fix-secondary'));
            btn.addEventListener('click',async()=>{
              if(busy)return; busy=true; dialog.querySelectorAll('button').forEach(b=>b.disabled=true); status.textContent='Updating your gloves…';
              let added=false;
              try{
                const fresh=await cart();
                if(fingerprint(fresh)!==fingerprint(c))throw new Error('Your cart changed. Close this window and check your setup again.');
                await json('cart/add.js',{items:[{id:v.id,quantity:w.glove.quantity}]}); added=true;
                await json('cart/change.js',{id:w.glove.key,quantity:0});
                close();
                await refreshCart();
              }catch(e){
                if(added){try{const now=await cart();const addedLine=now.items.find(i=>i.variant_id===v.id && !Object.keys(i.properties||{}).length);if(addedLine)await json('cart/change.js',{id:addedLine.key,quantity:0});}catch{status.textContent='Please review your cart: the recommended gloves may have been added alongside your original gloves.';busy=false;dialog.querySelectorAll('button').forEach(b=>b.disabled=false);return;}}
                status.textContent=e.message;
              }finally{busy=false;dialog.querySelectorAll('button').forEach(b=>b.disabled=false);}
            });
          }else{
            fix.append(node('p','What changes: you\'ll pick a glove version with loop Velcro on the glove page.','ihp-fix-change'));
            const edit=node('a','Fix issue: choose compatible gloves','button ihp-fix-button');edit.href=root+'products/slider-gloves';fix.append(edit);
            fix.append(editBacking('Or change the backing instead','ihp-fix-secondary'));
          }
        }catch{fix.append(node('p','Check the glove product page for available sizes.','ihp-fix-change'));fix.append(editBacking('Fix issue: edit backing','button ihp-fix-button'));}
      }
    }
    lastFocus=document.activeElement;
    if(!dialog.open)dialog.showModal();
  }
  async function check(proceed) {
    if(busy)return;
    busy=true;
    try{await show(await cart(),proceed);}catch(e){
      // A transient checker failure must not disable the existing store checkout.
      if(proceed)proceed();
    }finally{busy=false;}
  }
  function checkout(event) {
    const trigger=event.target.closest?.('[name="checkout"], a[href]');
    if(!trigger || trigger.disabled)return;
    if(trigger.tagName==='A' && !/^\/([^/]+\/)?checkout(?:[/?#]|$)/.test(new URL(trigger.href,location.origin).pathname))return;
    if(trigger.tagName!=='A' && trigger.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();
    check(()=>location.assign(root+'checkout'));
  }
  if(!embeddedEditor)document.addEventListener('click',checkout,true);
  document.addEventListener('submit',event=>{
    if(event.submitter?.name==='checkout'){event.preventDefault();event.stopImmediatePropagation();check(()=>location.assign(root+'checkout'));}
  },true);
  dialog.querySelector('[data-ihp-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{if(busy){event.preventDefault();return;}lastFocus?.focus();});
  dialog.querySelector('[data-ihp-continue]').addEventListener('click',async()=>{
    if(busy)return;
    if(!resume){close();return;}
    busy=true;
    try{const fresh=await cart();if(fingerprint(fresh)===resume.fingerprint)resume.proceed();else await show(fresh,resume.proceed);}catch{status.textContent='Unable to check your cart. Please close this window and try again.';}finally{busy=false;}
  });
  let lastCart=null;
  document.addEventListener('click',event=>{
    if(embeddedEditor || reconfigure || !event.target.closest('product-form button[name="add"]'))return;
    const before=lastCart;
    let attempts=0;
    const poll=async()=>{try{const fresh=await cart();if(before && fingerprint(fresh)!==fingerprint(before)){lastCart=fresh;check(null);return;}if(++attempts<6)setTimeout(poll,700);}catch{}};
    setTimeout(poll,700);
  },true);
  let timer;
  function schedule(){clearTimeout(timer);timer=setTimeout(async()=>{try{const c=await cart();lastCart=c;renderGuide();const count=evaluate(c.items,rules).length;document.querySelectorAll('[data-ihp-cart-notice]').forEach(el=>{el.hidden=!count;});}catch{}},200);}
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{schedule();if(event.source==='product-form' && !embeddedEditor && !reconfigure)setTimeout(()=>check(null),350);});
  document.addEventListener('click',e=>{if(e.target.closest('[data-ihp-cart-notice]'))check(null);});
  const productHandle=config.dataset.productHandle;
  const pageRule=rules.find(r=>norm(r.handle)===norm(productHandle));
  let renderGuide=()=>{};
  const form=document.querySelector('product-info product-form, .product__info-container product-form');
  const scope=form?.closest('product-info, .product__info-container')||document.body;
  function placeOptions(){
    const app=scope.querySelector('optionize-app');
    if(!app)return;
    const picker=scope.querySelector('variant-selects, variant-radios');
    if(picker){
      const next=picker.nextElementSibling;
      if(next===app||(next?.classList.contains('ihp-attachment-guide')&&next.nextElementSibling===app))return;
      picker.after(app);
      return;
    }
    // Single-variant products have no picker, so the options go right above the buy buttons.
    const buyBlock=form.closest('.product__info-container > *');
    if(!buyBlock||buyBlock.previousElementSibling===app)return;
    buyBlock.before(app);
  }
  if(form && pageRule && pageRule.area!=='foot' && !embeddedEditor){
      const area=pageRule.area==='fingers'?'fingers':'palm';
      const guide=node('div',null,'ihp-attachment-guide');
      guide.setAttribute('aria-live','polite');
      const icon=node('span','!','ihp-attachment-guide__icon');
      icon.setAttribute('aria-hidden','true');
      const title=node('p',null,'ihp-attachment-guide__title');
      const tip=node('p',null,'ihp-attachment-guide__tip');
      const verdict=node('p',null,'ihp-attachment-guide__check');
      const body=node('div',null,'ihp-attachment-guide__body');
      body.append(title,tip,verdict);
      guide.append(icon,body);
      const rich=parts=>parts.map(p=>Array.isArray(p)?node('strong',p[0]):document.createTextNode(p));
      const chosen=label=>{
        const name=norm(label).replace(/:$/,'');
        const option=[...scope.querySelectorAll('.oz__option')].find(o=>norm(o.querySelector('.oz__option-label')?.firstChild?.textContent).replace(/:$/,'')===name);
        return option?[...option.querySelectorAll('.oz__option-value--selected')].map(b=>norm(b.textContent)):[];
      };
      const tips={
        loop:['You have ',[`Slider Gloves with ${area} velcro`],', so choose ',['Velcro → Hook Velcro'],'. It sticks right to your gloves.'],
        noloop:[`Your Slider Gloves have no ${area} velcro, so choose `,['3M Adhesive'],' or ',['Velcro with Hook + Loop'],'.'],
        none:['Using your own gloves? Choose ',['Velcro with Hook + Loop'],` (loop goes on your glove ${area}) or `,['3M Adhesive'],'.']
      };
      function selectionCheck(state){
        const backing=chosen(pageRule.backing_property)[0]||'', side=chosen(pageRule.side_property);
        const hook=side.some(s=>/\bhook\b/.test(s)), loop=side.some(s=>/\bloop\b/.test(s));
        if(backing==='none')return [false,'No backing selected. You will need E6000 glue or your own attachment.'];
        if(backing.includes('3m'))return state==='loop'?[false,'3M won’t use your glove velcro. Switch to Velcro → Hook.']:[true,'3M Adhesive sticks this item directly to your glove.'];
        if(!backing.includes('velcro')||(!hook&&!loop))return null;
        if(!hook)return [false,'Add Hook Velcro. It goes on this item.'];
        if(state==='loop')return loop?[false,'Your gloves already have loop. Hook only is enough.']:[true,'Hook on this item sticks right to the loop on your gloves.'];
        if(!loop)return [false,state==='none'?'Add Loop too, unless your gloves already have velcro.':`Add Loop too. Your gloves have no ${area} velcro.`];
        return [true,'Loop goes on your glove, hook goes on this item.'];
      }
      let lastKey='';
      renderGuide=()=>{
        const anchor=scope.querySelector('optionize-app')||form;
        if(guide.nextElementSibling!==anchor)anchor.before(guide);
        const gloves=evaluate(lastCart?.items||[],rules).openGloves(pageRule.area);
        const state=!gloves.length?'none':gloves.some(g=>hasLoop(g,pageRule.area))?'loop':'noloop';
        const result=selectionCheck(state);
        const key=state+JSON.stringify(result);
        if(key===lastKey)return;
        lastKey=key;
        const good=result?.[0]===true;
        guide.dataset.state=good?'ok':'tip';
        icon.textContent=good?'✓':'!';
        title.textContent=good?'Good match for your setup':'Pick the right backing';
        tip.replaceChildren(...(good?[document.createTextNode(result[1])]:rich(tips[state])));
        verdict.hidden=!result||good;
        if(result){verdict.textContent=result[1];verdict.dataset.state=result[0]?'ok':'warn';}
      };
  }
  if(form && !embeddedEditor){
    let frame;
    const refresh=()=>{placeOptions();renderGuide();};
    new MutationObserver(records=>{
      if(records.every(r=>r.target.closest?.('.ihp-attachment-guide')))return;
      cancelAnimationFrame(frame);frame=requestAnimationFrame(refresh);
    }).observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
    refresh();
  }
  schedule();
  window.IHPCompatibility={evaluate,check:()=>check(null)};
})();
